/* tslint:disable */
/* eslint-disable */
/**
 * Consolidate Legacy API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InlineObject10
 */
export interface InlineObject10 {
    /**
     * 
     * @type {number}
     * @memberof InlineObject10
     */
    aktid: number;
    /**
     * 
     * @type {number}
     * @memberof InlineObject10
     */
    priority: number;
}

export function InlineObject10FromJSON(json: any): InlineObject10 {
    return InlineObject10FromJSONTyped(json, false);
}

export function InlineObject10FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineObject10 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'aktid': json['aktid'],
        'priority': json['priority'],
    };
}

export function InlineObject10ToJSON(value?: InlineObject10 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'aktid': value.aktid,
        'priority': value.priority,
    };
}


